var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home bg bg--smb"},[_c('div',{staticClass:"error-box"},[_vm._v("\n    Sorry Mario, your princess is in "),_c('router-link',{staticClass:"error-box__link",attrs:{"to":"/"}},[_vm._v("another castle")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }